import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingScreenService {

  private _loading = false;
  loadingStatus: Subject<any> = new Subject<any>();

  get loading(): boolean {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
    this.loadingStatus.next(value);
  }

  async startLoading() {
    this.loading = true;
  }

  async stopLoading() {
    this.loading = false;
  }
}
